bcl.c.interactiveMap = {
  props: {
    dynamicClass: ".c-interactive-map.dynamicLoading",
    mapContainerDivClass: ".interactive-map__background",
    imageMapClass: ".cmp-image__image",
    ctaChildClass: ".interactive-map__cta-JS",
    imageParentElement: null,
    naturalHeight: null,
    naturalWidth: null,
    aspect: null,
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-interactiveMap.css", this.props.dynamicClass);

    const imageContainer = document.querySelector(bcl.c.interactiveMap.props.mapContainerDivClass);

    if (imageContainer) {
      bcl.c.interactiveMap.props.imageParentElement = imageContainer;
      const image = imageContainer.querySelector(bcl.c.interactiveMap.props.imageMapClass);

      if (image) {
        const handleScroll = bcl.u.debounce(
          function () {
            if (bcl.u.isInViewport(image)) {
              window.removeEventListener("scroll", handleScroll);
              bcl.c.interactiveMap.calculateRealSize(image);
            }
          },
          250,
          null,
        );

        window.addEventListener("scroll", handleScroll);
      }
    }
  },

  calculateRealSize: function (img) {
    bcl.c.interactiveMap.naturalWidth = img.naturalWidth;
    bcl.c.interactiveMap.naturalHeight = img.naturalHeight;

    const gdc = bcl.c.interactiveMap.gdc(bcl.c.interactiveMap.naturalWidth, bcl.c.interactiveMap.naturalHeight);

    if (gdc) {
      bcl.c.interactiveMap.calculateAspect(gdc);
    }
  },

  //greatest common divisor
  gdc: function (width, height) {
    return height == 0 ? width : bcl.c.interactiveMap.gdc(height, width % height);
  },

  calculateAspect: function (gdc) {
    const aspectWidth = bcl.c.interactiveMap.naturalWidth / gdc,
      aspectHeight = bcl.c.interactiveMap.naturalHeight / gdc,
      finalHeight = (aspectHeight * 100) / aspectWidth;

    const parentNode = bcl.c.interactiveMap.props.imageParentElement.parentNode;
    bcl.c.interactiveMap.props.parentNodeElement = parentNode;

    parentNode.style.height = finalHeight.toFixed(4) + "vw";
  },
};

bcl.u.docReady(bcl.c.interactiveMap.init);
